import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { LanguageService } from './services/language.service';
import { NavigationService } from './services/navigation.service';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
  `,
  styles: []
})
export class AppComponent implements OnInit {
  constructor(private router: Router,
    private languageService: LanguageService,
    private navigation: NavigationService,          
    private bsLocalService: BsLocaleService,
    private title: Title,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId:Object) {
      this.title.setTitle(environment.company + $localize` - Medicina ancestral, tecnología de punta y soporte terapéutico trabajando juntos`);
      this.meta.updateTag({name: "description", content: $localize`Somos un movimiento que busca aliviar el sufrimiento humano, conectando a las personas con su corazón, con su verdadera naturaleza y con la vida mediante procesos de crecimiento y transformación que hagan a las personas libres, responsables y copartícipes de su salud.`})
    }

  ngOnInit() {
    this.navigation.startHistorySave();
    this.bsLocalService.use(this.languageService.getLanguage())
    this.router.events.subscribe(event=>{
      if (event instanceof NavigationEnd&& isPlatformBrowser(this.platformId)) {
        localStorage.setItem('userCurrentPath', event.urlAfterRedirects);        
      }
    })
  }
}